import actions from "actions";
import constants from "constants";
import React, { Component } from "react";
import { connect } from "react-redux";
import storage from "services/storage.js";
import Webinar from "./Webinar";
import { clearTempWebinar } from "../../../actions/webinars";
import { Link } from "react-router";

const { loadVimeoVideoDataSaga, showModal, loadWebinarSaga } = actions;

const { MODAL_TYPE_QUIZ } = constants;

class StudyGroupSuperhostAudioWebinar extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.clearTempWebinar();
  }

  componentWillMount() {
    const webinarId = parseInt(
      (this.props.params && this.props.params.webinarId) || ""
    );
    this.props.loadWebinar(webinarId, this.props.params.id);
  }

  showQuizModal = () => {
    this.props.showQuizModal({
      webinar: this.props.webinar,
    });
  };

  render() {
    const token = storage.getSessionData().session.token;

    return (
      <div>
        <Link
          to={`/groups/${groupId}/webinars/recorded`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginLeft: 12,
            marginTop: 24,
            marginBottom: 24,
          }}
        >
          <img
            style={{ width: 24, height: 24 }}
            src={arrowBack}
            alt="arrow-back"
          />
          <div
            style={{
              textDecoration: "underline",
              textDecorationColor: "#039be5",
            }}
          >
            Return to Webinars
          </div>
        </Link>
        <Webinar
          token={token}
          webinar={this.props.webinar}
          linkToFeedbackForm={this.linkToFeedbackForm}
          startQuiz={this.showQuizModal}
          userRole={this.props.userRole}
          groupId={this.props.params.id}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  webinar: state.webinars.tmp,
  userRole: state.users.user.user_type,
});

const mapDispatchToProps = (dispatch) => ({
  showQuizModal: (contentProps) =>
    dispatch(showModal(MODAL_TYPE_QUIZ, contentProps)),
  loadWebinar: (webinarId, groupId) =>
    dispatch(loadWebinarSaga(webinarId, true, true, true, false, groupId)),
  clearTempWebinar: () => dispatch(clearTempWebinar()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostAudioWebinar);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostAudioWebinar/index.jsx